import React, { useState, useEffect } from 'react';

const COOKIE_NAME = 'cookieConsent';
const COOKIE_EXPIRATION_HOURS = 24;

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_NAME);
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    const expirationTime = new Date();
    expirationTime.setHours(expirationTime.getHours() + COOKIE_EXPIRATION_HOURS);
    const consentData = {
      accepted: true,
      expires: expirationTime.getTime()
    };
    localStorage.setItem(COOKIE_NAME, JSON.stringify(consentData));
    setShowBanner(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const consentData = JSON.parse(localStorage.getItem(COOKIE_NAME));
      if (consentData && consentData.expires < Date.now()) {
        localStorage.removeItem(COOKIE_NAME);
        setShowBanner(true);
      }
    }, 60000); // kontrola každú minútu
    return () => clearInterval(interval);
  }, []);

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      width: '100%',
      backgroundColor: '#0a2e5c',
      color: '#ffffff',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <p style={{ marginBottom: '10px', textAlign: 'center', maxWidth: '800px' }}>
        Táto stránka používa súbory cookies na zber anonymných analytických údajov s cieľom zlepšiť funkčnosť a používateľský zážitok. Svoj súhlas môžete kedykoľvek odvolať.
      </p>
      <button
        onClick={acceptCookies}
        style={{
          backgroundColor: '#ffffff',
          color: '#0a2e5c',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '5px',
          fontWeight: 'bold',
          cursor: 'pointer'
        }}
      >
        Súhlasím
      </button>
    </div>
  );
}
